import type { FaireProductEntity } from "../../entity_types/product";

export const p_vcsccz8kxs: FaireProductEntity = {
  token: "p_vcsccz8kxs",
  type: "product",
  name: "Cocoa Felice Hot Chocolate Mix",
  brandToken: "b_27yaz87n28",
  brandName: "Coop's",
  imageUrl:
    "https://cdn.faire.com/fastly/a68beccab69f92515c6d40f56b9c9118e76997635d206ed8aeb8322aaab3e4f2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2ddde16af9ef0b0a3a2ef534a52c0cfff526381d1173572af0c3b18748c56764.jpeg",
    "https://cdn.faire.com/fastly/20c4895a2590fb391463373471e76e2bbd23ddf374099779a1d4daf60bfeb77a.jpeg",
    "https://cdn.faire.com/fastly/ba3b1b71a46bc33016d390e6cb1ce2a8d094087936b60d9a3398de700076bc86.jpeg",
  ],
  priceDollars: 8.45,
  description:
    "In new, 100% recyclable packaging, Cocoa Felice is made using the finest European chocolate for the richest, most scrumptious chocolaty drink imaginable.\n\nMix it with whole milk, skim milk, or coconut, soy, almond or rice milk for a vegan, dairy free alternative.\n\nCocoa Felice is an excellent Christmas and holiday gift - pairing perfectly with Coop's sauces for a doubly decadent drink.",
  tags: [],
  msrpDollars: 15.2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:14.870Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
